<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <!-- begin: Import Modal -->
      <div
        class="modal fade"
        id="importBudgetPlanModal"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import แผนงบประมาณ</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form ref="importForm">
                <div class="form-group">
                  <label>ปีงบประมาณ <span class="text-danger">*</span></label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'importYearSelect'"
                    :name="'importYearSelect'"
                    :select2-options="yearOptions"
                    v-model="importYear"
                    ref="importYearSelect2"
                  ></select2>
                </div>
                <div class="form-group">
                  <label>ไฟล์ Excel (.xlsx) <span class="text-danger">*</span></label>
                  <div class="custom-file">
                    <input
                      type="file"
                      class="custom-file-input"
                      id="importFile"
                      accept=".xlsx"
                      @change="onFileChange"
                      ref="importFileInput"
                    />
                    <label class="custom-file-label" for="importFile">
                      {{ importFileName || 'เลือกไฟล์...' }}
                    </label>
                  </div>
                  <small class="form-text text-muted">
                    รองรับไฟล์ .xlsx เท่านั้น
                  </small>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                ยกเลิก
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="submitImport"
                :disabled="!importYear || !importFile"
              >
                <i class="fas fa-upload"></i> นำเข้าข้อมูล
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end: Import Modal -->

      <div
        v-show="$route.path == '/BudgetPlan/List'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-file-invoice-dollar"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>CCTR :</label>
                  <input
                    v-model="searchCCTR"
                    type="text"
                    class="form-control"
                    placeholder="พิมพ์คำค้นหาจาก รหัส CCTR, ชื่อ CCTR สามารถคั่นระหว่างคำด้วย(ลูกน้ำ) เช่น 122570268,122570269"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>ปีงบประมาณ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'budgetList_yearKey'"
                    :name="'budgetList_yearKey'"
                    :select2-options="searchYearOptions"
                    v-model="searchYear"
                    ref="budgetList_yearKeySelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'budgetList_statusKey'"
                    :name="'budgetList_statusKey'"
                    :select2-options="statusOptions"
                    v-model="searchStatus"
                    ref="budgetList_statusKeySelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  ค้นหา
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  v-if="canEdit"
                  type="button"
                  class="btn btn-info"
                  @click="downloadTemplate"
                >
                  <i class="fas fa-download"></i> Download Template
                </button>
                <button
                  v-if="canEdit"
                  type="button"
                  class="btn btn-success"
                  @click="showImportModal"
                >
                  <i class="fas fa-file-import"></i> Import แผนงบประมาณ
                </button>
                <button
                  v-if="canEdit"
                  type="button"
                  class="btn btn-primary"
                  @click="goToCreate"
                >
                  <i class="fas fa-plus"></i> เพิ่มแผนงบประมาณ
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="budgetPlanTable"
              >
                <thead>
                  <tr>
                    <th class="all text-center" style="width: 15%;">รหัส CCTR</th>
                    <th class="all text-center" style="width: 35%;">ชื่อ CCTR</th>
                    <th class="all text-center" style="width: 15%;">ปีงบประมาณ</th>
                    <th class="all text-center" style="width: 12%;">วันที่บันทึกล่าสุด</th>
                    <th class="all text-center" style="width: 13%;">สถานะ</th>
                    <th class="all text-center" style="width: 10%;">คำสั่ง</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../router";
import select2 from "../../Shared/Select2";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-bs4");
require("datatables.net-responsive-bs4");
require("sweetalert2");

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a v-if="canEdit" href="#" class="btn btn-sm btn-success" @click.prevent="toggleStatus">
      <i class="fas fa-play"></i> เปิดใช้งาน
    </a>
    <span v-else class="badge badge-success">เปิดใช้งาน</span>
  </div>`,
  props: ['canEdit'],
  methods: {
    toggleStatus: function() {
      let self = this;

      // Check if this CostCenter has used jobs - cannot deactivate
      if (this.data.hasUsedJobs) {
        Swal.fire({
          title: "ไม่สามารถปิดสถานะได้",
          type: "warning",
          html: "ไม่สามารถปิดสถานะได้ เนื่องจากมีการใช้งบประมาณภายใต้ CCTR นี้แล้ว",
          confirmButtonText: "ตกลง",
        });
        return;
      }

      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขสถานะ กรุณารอสักครู่...",
          });

          axios
            .put(`/Api/BudgetPlan/CostCenter/${this.data.year}/${this.data.costCenterCode}/ToggleStatus`, {}, {
              headers: {
                Authorization: "Bearer " + self.$root.user.access_token,
              },
            })
            .then(function(response) {
              if (response.data.success) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", "ปรับปรุงสถานะการใช้งานสำเร็จ", "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              var errorMsg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : "เกิดข้อผิดพลาด";
              Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
            })
            .then(function() {
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a v-if="canEdit" href="#" class="btn btn-sm btn-danger" @click.prevent="toggleStatus">
      <i class="fas fa-pause"></i> ปิดใช้งาน
    </a>
    <span v-else class="badge badge-danger">ปิดใช้งาน</span>
  </div>`,
  props: ['canEdit'],
  methods: {
    toggleStatus: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขสถานะ กรุณารอสักครู่...",
          });

          axios
            .put(`/Api/BudgetPlan/CostCenter/${this.data.year}/${this.data.costCenterCode}/ToggleStatus`, {}, {
              headers: {
                Authorization: "Bearer " + self.$root.user.access_token,
              },
            })
            .then(function(response) {
              if (response.data.success) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", "ปรับปรุงสถานะการใช้งานสำเร็จ", "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              var errorMsg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : "เกิดข้อผิดพลาด";
              Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
            })
            .then(function() {
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

let BudgetPlanActions = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="viewBudgetPlan" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ดูรายละเอียด">
      <i class="fas fa-search"></i>
    </a>
    <a v-if="canEdit" href="#" @click.prevent="editBudgetPlan" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขข้อมูล">
      <i class="la la-edit"></i>
    </a>
    <a v-if="canEdit" href="#" @click.prevent="deleteBudgetPlan" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ลบข้อมูล">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  props: ['canEdit'],
  methods: {
    viewBudgetPlan: function () {
      router.push({ path: `/BudgetPlan/View/${this.data.year}/${this.data.costCenterCode}` });
    },
    editBudgetPlan: function () {
      router.push({ path: `/BudgetPlan/Edit/${this.data.year}/${this.data.costCenterCode}` });
    },
    deleteBudgetPlan: function () {
      let self = this;

      // Check if this CostCenter has used jobs - cannot delete
      if (this.data.hasUsedJobs) {
        Swal.fire({
          title: "ไม่สามารถลบได้",
          type: "warning",
          html: "ไม่สามารถลบได้ เนื่องจากมีการใช้งบประมาณภายใต้ CCTR นี้แล้ว",
          confirmButtonText: "ตกลง",
        });
        return;
      }

      Swal.fire({
        title: "ยืนยันการลบ",
        type: "warning",
        html: "คุณต้องการลบข้อมูล Cost Center นี้หรือไม่?",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .post(`/Api/BudgetPlan/CostCenter/${this.data.year}/${this.data.costCenterCode}/Delete`)
            .then(function (response) {
              if (response.data.success) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function (error) {
              var errorMsg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : "เกิดข้อผิดพลาด";
              Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
            })
            .then(function () {
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
  },
  computed: {
    // ตรวจสอบว่า user มีสิทธิ์แก้ไขได้หรือไม่ (BUDGET_PLAN_REVIEWER หรือ BUDGET_PLAN_MANAGER)
    canEdit: function () {
      return this.$root.canShowExSuperAdmin([
        ['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'],
        ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']
      ]);
    }
  },
  data: function () {
    // Generate year options: current year+1, current year, current year-1 to -4
    const currentYear = new Date().getFullYear();
    const yearData = [
      { id: (currentYear + 1).toString(), text: (currentYear + 1).toString() },
      { id: currentYear.toString(), text: currentYear.toString() },
      { id: (currentYear - 1).toString(), text: (currentYear - 1).toString() },
      { id: (currentYear - 2).toString(), text: (currentYear - 2).toString() },
      { id: (currentYear - 3).toString(), text: (currentYear - 3).toString() },
      { id: (currentYear - 4).toString(), text: (currentYear - 4).toString() },
    ];

    // Import year options: only current year and current year + 1
    const importYearData = [
      { id: (currentYear + 1).toString(), text: (currentYear + 1).toString() },
      { id: currentYear.toString(), text: currentYear.toString() },
    ];

    // Search year options (same list but with allowClear)
    const searchYearData = yearData.slice(); // copy array

    return {
      searchCCTR: "",
      searchYear: currentYear.toString(), // Default: current year
      searchStatus: "1", // Default: ใช้งาน
      searchYearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: true,
        data: searchYearData,
      },
      statusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "1", text: "ใช้งาน" },
          { id: "0", text: "ไม่ใช้งาน" },
        ],
      },
      // Import Modal
      importYear: null,
      importFile: null,
      importFileName: "",
      yearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: false,
        data: importYearData, // Import: เฉพาะปีปัจจุบันและปีถัดไป
      },
      // Store import rows for error export
      lastImportRows: null,
    };
  },
  methods: {
    downloadTemplate: function () {
      // Create a temporary link element to trigger download
      const link = document.createElement('a');
      link.href = '/Template/Budget Approval_Import_Template.xlsx';
      link.download = 'Budget Approval_Import_Template.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    formReset: function (e) {
      this.searchCCTR = "";
      this.searchYear = null;
      this.searchStatus = null;
      $("#budgetList_statusKey").val("").trigger("change");
      $("#budgetList_yearKey").val("").trigger("change");
      this.formSubmit(e);
    },
    formSubmit: function (e) {
      e.preventDefault();
      var table = $("#budgetPlanTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function (resetPaging = false) {
      $("#budgetPlanTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    // Import Modal Methods
    showImportModal: function () {
      this.resetImportForm();
      $("#importBudgetPlanModal").modal("show");
    },
    resetImportForm: function () {
      this.importYear = null;
      this.importFile = null;
      this.importFileName = "";
      if (this.$refs.importFileInput) {
        this.$refs.importFileInput.value = "";
      }
      $("#importYearSelect").val("").trigger("change");
    },
    onFileChange: function (e) {
      const file = e.target.files[0];
      if (file) {
        // Validate file extension
        const ext = file.name.split(".").pop().toLowerCase();
        if (ext !== "xlsx") {
          Swal.fire("ผิดพลาด", "กรุณาเลือกไฟล์ .xlsx เท่านั้น", "error");
          this.$refs.importFileInput.value = "";
          this.importFile = null;
          this.importFileName = "";
          return;
        }
        this.importFile = file;
        this.importFileName = file.name;
      } else {
        this.importFile = null;
        this.importFileName = "";
      }
    },
    submitImport: function () {
      if (!this.importYear) {
        Swal.fire("ผิดพลาด", "กรุณาเลือกปีงบประมาณ", "warning");
        return;
      }
      if (!this.importFile) {
        Swal.fire("ผิดพลาด", "กรุณาเลือกไฟล์ Excel", "warning");
        return;
      }

      let self = this;
      const formData = new FormData();
      formData.append("file", this.importFile);
      formData.append("year", this.importYear);

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังนำเข้าข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/BudgetPlan/Import", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (response) {
          if (response.data.success) {
            $("#importBudgetPlanModal").modal("hide");
            self.reloadDataTable(true);

            // Show result summary
            const result = response.data.data;
            let message = `นำเข้าข้อมูลสำเร็จ<br/>`;
            message += `- จำนวนที่นำเข้า: ${result.importedCount || 0} รายการ<br/>`;
            if (result.errorCount > 0) {
              message += `- จำนวนที่ผิดพลาด: ${result.errorCount} รายการ`;
            }

            Swal.fire({
              title: "สำเร็จ",
              html: message,
              type: "success",
            });
          } else {
            // Store import rows for error export
            self.lastImportRows = response.data.importRows || null;

            // Show validation errors with download button
            let errorHtml = `<p>${response.data.message || "นำเข้าข้อมูลไม่สำเร็จ"}</p>`;

            if (self.lastImportRows && self.lastImportRows.length > 0) {
              errorHtml += `<p>คลิก <strong>ดาวน์โหลด Error Detail</strong> เพื่อดูรายละเอียด</p>`;
            }

            Swal.fire({
              title: "นำเข้าข้อมูลไม่สำเร็จ",
              html: errorHtml,
              type: "error",
              showCancelButton: self.lastImportRows && self.lastImportRows.length > 0,
              confirmButtonText: "ตกลง",
              cancelButtonText: '<i class="fas fa-download"></i> ดาวน์โหลด Error Detail',
              cancelButtonColor: "#5867dd",
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.cancel) {
                // Download error detail
                self.downloadErrorDetail();
              }
            });
          }
        })
        .catch(function (error) {
          var message = "เกิดข้อผิดพลาดในการนำเข้าข้อมูล";
          if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          Swal.fire("เกิดข้อผิดพลาด", message, "error");
        })
        .then(function () {
          KTApp.unblockPage();
        });
    },
    goToCreate: function () {
      router.push({ path: "/BudgetPlan/Create" });
    },
    downloadErrorDetail: function () {
      if (!this.lastImportRows || this.lastImportRows.length === 0) {
        Swal.fire("ผิดพลาด", "ไม่พบข้อมูลสำหรับ export", "warning");
        return;
      }

      let self = this;
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังสร้างไฟล์ กรุณารอสักครู่...",
      });

      axios
        .post(
          "/Api/BudgetPlan/ExportErrors",
          {
            importRows: this.lastImportRows,
            year: this.importYear,
          },
          {
            responseType: "blob",
          }
        )
        .then(function (response) {
          // Create download link
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;

          // Get filename from header or use default
          const contentDisposition = response.headers["content-disposition"];
          let filename = "BudgetPlan_ImportErrors.xlsx";
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
              filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ""));
            }
          }

          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดาวน์โหลดไฟล์ได้", "error");
        })
        .then(function () {
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;

    // Set default values for dropdowns
    await this.$nextTick();
    const currentYear = new Date().getFullYear();
    $("#budgetList_statusKey").val("1").trigger("change");
    $("#budgetList_yearKey").val(currentYear.toString()).trigger("change");

    $.fn.dataTable.ext.errMode = "none";
    var table = $("#budgetPlanTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/BudgetPlan/CostCenter/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function (d) {
            return JSON.stringify(
              $.extend(d, {
                CostCenterCode: self.searchCCTR,
                Year: self.searchYear,
                Status: self.searchStatus,
              })
            );
          },
        },
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [50, 100, 200, 500],
        pageLength: 100,
        language: {
          lengthMenu: "Display _MENU_",
        },
        order: [[0, "asc"], [2, "desc"]],  // Sort by CCTR (asc), then Year (desc)
        columns: [
          { data: "costCenterCode", className: "text-center", width: "15%" },
          { data: "costCenterName", className: "text-center", width: "35%" },
          { data: "year", className: "text-center", width: "15%" },
          {
            data: "modifiedDate",
            className: "text-center",
            width: "12%",
            render: function (data, type, full, meta) {
              if (data) {
                var d = new Date(data);
                var day = String(d.getDate()).padStart(2, '0');
                var month = String(d.getMonth() + 1).padStart(2, '0');
                var year = d.getFullYear();
                return day + "/" + month + "/" + year;
              }
              return "-";
            },
          },
          {
            data: "isActive",
            className: "text-center",
            width: "13%",
            orderable: false,
            render: function (data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "id",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function (data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function () {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("error.dt", function (e, settings, techNote, message) {
        DatatableWarning.alert(techNote);
      })
      .on("xhr.dt", function () {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("draw.dt", function () {
        $(".actionsStatus").each(function (i, el) {
          var $dt = table.DataTable();
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            // InActiveStatus: 0 = Active, 1 = Inactive
            // isActive (from query): true = Active, false = Inactive
            if (data.isActive) {
              new StatusActionsTrue({ data: { data }, parent: self, propsData: { canEdit: self.canEdit } }).$mount(el);
            } else {
              new StatusActionsFalse({ data: { data }, parent: self, propsData: { canEdit: self.canEdit } }).$mount(el);
            }
          }
        });
        $(".actions").each(function (i, el) {
          var $dt = table.DataTable();
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            new BudgetPlanActions({ data: { data }, parent: self, propsData: { canEdit: self.canEdit } }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss">
.select2,
.select2-dropdown {
  font-size: 1rem !important;
}
</style>



// WEBPACK FOOTER //
// App/Components/BudgetPlan/BudgetPlanList.vue